import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoabastecimentoexterno(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoabastecimentoexterno/FIND_OPERACAOABASTECIMENTOEXTERNO':
      case '@operacaoabastecimentoexterno/UPDATE_OPERACAOABASTECIMENTOEXTERNO':
      case '@operacaoabastecimentoexterno/DELETE_OPERACAOABASTECIMENTOEXTERNO':
      case '@operacaoabastecimentoexterno/STORE_OPERACAOABASTECIMENTOEXTERNO':
      case '@operacaoabastecimentoexterno/REFRESH':
      case '@operacaoabastecimentoexterno/OPERACAOABASTECIMENTOEXTERNO_IN_REQUEST': {
        draft.loading = true;
        // draft.find = null;
        break;
      }

      case '@operacaoabastecimentoexterno/SUCCESS_REMOVE':
      case '@operacaoabastecimentoexterno/FAILED_REQUEST': {
        draft.loading = false;
        // draft.find = null;
        break;
      }

      case '@operacaoabastecimentoexterno/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoabastecimentoexterno;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoabastecimentoexterno/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoabastecimentoexterno;
        break;
      }

      case '@operacaoabastecimentoexterno/RECORD_FILTERING': {
        draft.loading = true;
        draft.find = null;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
